/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboForexManagementBadRequestResponse,
  BboForexManagementCountTypeDetailResponseResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  GetCurrencyParams,
  NotFoundResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get the list currencies available
 * @summary Get the currencies available.
 */
export const getCurrency = (params: GetCurrencyParams, signal?: AbortSignal) => {
  return customInstance<BboForexManagementCountTypeDetailResponseResponse>({
    url: `/BboForexManagementService/v1/fetch-currencies`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetCurrencyQueryKey = (params: GetCurrencyParams) => {
  return [`/BboForexManagementService/v1/fetch-currencies`, ...(params ? [params] : [])] as const;
};

export const getGetCurrencyQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrency>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(
  params: GetCurrencyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrencyQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrency>>> = ({ signal }) =>
    getCurrency(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrency>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrencyQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrency>>>;
export type GetCurrencyQueryError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | NotFoundResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary Get the currencies available.
 */
export const useGetCurrency = <
  TData = Awaited<ReturnType<typeof getCurrency>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(
  params: GetCurrencyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCurrencyQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
